<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('advertisers')">Anunciante</inertia-link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.usuario }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.usuario" :error="form.errors.usuario" class="pr-6 pb-8 w-full lg:w-1/2" label="Usuario" />
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
          <text-input v-model="form.correo" :error="form.errors.correo" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.fono" :error="form.errors.fono" class="pr-6 pb-8 w-full lg:w-1/2" label="Telefono" />
          <text-input v-model="form.senia" :error="form.errors.senia" class="pr-6 pb-8 w-full lg:w-1/2" label="Password" />
         
          <div class="ml-4">
            <label class="form-label" :for="id">Temporada 2026:</label>
            <input key="active" type="checkbox" v-model="form.sindeudas26" class="form-checkbox h-5 w-5 text-blue-600 transition duration-150 ease-in-out" />
            <div v-if="form.errors.sindeudas26" class="form-error">{{ form.errors.sindeudas26 }}</div>
          </div>
          <div class="ml-4">
            <label class="form-label" :for="id">Temporada 2027:</label>
            <input key="active" type="checkbox" v-model="form.sindeudas27" class="form-checkbox h-5 w-5 text-blue-600 transition duration-150 ease-in-out" />
            <div v-if="form.errors.sindeudas27" class="form-error">{{ form.errors.sindeudas27 }}</div>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
           <button v-if="advertiser.propiedades.length == 0" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Anunciante</button>
           <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Anunciante</loading-button>
        </div>
      </form>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden mt-4 " v-if="advertiser.propiedades.length > 0">
      <h1 class="p-8 font-bold text-3xl">Propiedades de {{ form.usuario }}</h1>
      <div class="grid xl:grid-cols-3  md:grid-cols-2 md:px-8 md:pb-12  md:gap-y-8 md:gap-x-8 md:pb-16">
        <div
          v-for="element in advertiser.propiedades"
          :key="element.ID"
          class="bg-white border-blue-200 relative  bg-white rounded-md shadow bg-opacity-95 border-opacity-60 | p-4 border-solid rounded border-1 | flex justify-around cursor-pointer | hover:bg-blue-100  hover:border-transparent | transition-colors duration-500"
        >
          <inertia-link class="text-blue-900" :href="route('properties.edit', element.ID)">
            <div class="flex flex-col ">
              <p class="text-blue-900 text-xl  font-semibold">
               
                  <icon name="home" :class="getClass(element.operacion)" class="w-8 h-8 p-1 absolute -top-1 -right-1 rounded mr-2 -mt-2 fill-white inline-block hover:fill-blue-100 " />
                {{ element.nombre }}
                </p>
              <p class="text-black  text-sm mt-4"><span v-html="element.descripcion_corta"></span></p>
            </div>
          </inertia-link>

          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";
import TextInput from "@/Shared/TextInput";
import TextAreaInput from "@/Shared/TextAreaInput";
import SelectInput from "@/Shared/SelectInput";
import LoadingButton from "@/Shared/LoadingButton";
import TrashedMessage from "@/Shared/TrashedMessage";

export default {
  metaInfo() {
    return { title: this.form.usuario };
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput
  },
  layout: Layout,
  props: {
    advertiser: Object
  },
  remember: "form",
  data() {
    return {
      form: this.$inertia.form({
        ID: this.advertiser.ID,
        usuario: this.advertiser.usuario,
        sindeudas24: this.advertiser.sindeudas24,
        sindeudas26: this.advertiser.sindeudas26,
        sindeudas27: this.advertiser.sindeudas27,
        nombre: this.advertiser.nombre,
        correo: this.advertiser.correo,
        fono: this.advertiser.fono,
        senia: this.advertiser.senia
      })
    };
  },
  methods: {
    getClass(el){
      if(el == '1') {
        return 'bg-indigo-500';
      } else if(el == '2') {
        return 'bg-green-500';
      }
      if(el == '3') {
        return 'bg-yellow-500';
     
      }
      return 'red';
    },
    update() {
      this.form.put(this.route("advertisers.update", this.advertiser.ID));
    },
    destroy() {
      if (confirm("Seguro que desea elimiar este anunciante?")) {
        this.$inertia.delete(this.route("advertisers.destroy", this.advertiser.ID));
      }
    }
  }
};
</script>
